import { makeStyles } from "../../../providers/makeStyles";
import { Typography } from "@mui/material";
import { T } from "../../../util/t";
import { formatPrice } from "../../../../utils/utils";
import { Fragment } from "react";

const useStyles = makeStyles(theme => ({
    summary: {
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2),
        marginTop: theme.spacing(2),
        background: theme.palette.background.low,
        position: "sticky",
        top: theme.spacing(2)
    },
    lineItem: {
        display: "flex",
        justifyContent: "space-between",
        marginBottom: theme.spacing(1),
        "&:last-child": {
            marginBottom: 0
        }
    },
    total: {
        borderTop: `1px solid ${theme.palette.border.light}`,
        paddingTop: theme.spacing(2),
        marginTop: theme.spacing(2),
    },
    sectionTitle: {
        marginTop: theme.spacing(2),
        "&:first-of-type": {
            marginTop: 0
        }
    }
}));

const LineItems = ({ items, currency, classes }) => items.map((item, i) =>
    <Typography key={i} className={classes.lineItem} component="div">
        <span>{item.text}</span>
        {item.total != null && <span>{formatPrice(item.total, currency)}</span>}
    </Typography>
);

export const WizardSummaryBox = ({ title, subtitle, lineItems, total, currency, discount, footer }) => {
    const classes = useStyles();

    return (
        <>
            <Typography variant="h7" component="h2"><T>{title}</T></Typography>
            {subtitle}
            <section className={classes.summary}>
                {Array.isArray(lineItems)
                    ? <LineItems items={lineItems} currency={currency} classes={classes} />
                    : Object.keys(lineItems).map(sectionTitle =>
                        <Fragment key={sectionTitle}>
                            <Typography variant="label1" component="h3" className={`${classes.lineItem} ${classes.sectionTitle}`}><T>{sectionTitle}</T></Typography>
                            <LineItems items={lineItems[sectionTitle]} currency={currency} classes={classes} />
                        </Fragment>
                    )}
                {total != null &&
                    <Typography className={`${classes.lineItem} ${classes.total}`} variant="label1" component="div">
                        <span><T>Total</T></span>
                        <span>{formatPrice(total, currency)}</span>
                    </Typography>
                }
                {discount != null &&
                    <Typography className={classes.lineItem} component="div" marginTop={2}>
                        <span>{discount.text}</span>
                        {discount.total && <span>{discount.total}</span>}
                    </Typography>
                }
            </section>
            {footer &&
                <Typography component="p" marginTop={2} variant="caption" color="text.secondary">{footer}</Typography>}
        </>
    );
};
